module.exports = __webpack_public_path__ + "dist/media/ec_comp_tags.8ffd11a4.svg";